var React = require('react');

function TreePalm (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M379.65,485c-2,15.63-16,27-31.71,27H292.81a31.91,31.91,0,0,1-32-31.82,31.46,31.46,0,0,1,.94-7.79c14.42-57.12,36.55-167.3,25.86-272L296,192h57.25C368.08,248.66,394.43,371.53,379.65,485Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M607.74,172.86C596.13,111.24,529.38,64,448.76,64c-39.43,0-75.05,11.74-103,30.5C327.15,40.17,265.38,0,191.25,0c-80.62,0-147.36,47.24-159,108.86C30.41,118.79,38.77,128,50,128h54l24-48,33.46,66.92C158,150,154.2,152.61,150.82,156c-57,57-70.82,137.6-35.44,189.38,5.7,8.34,18.12,8.94,26.07,1L296,192H488l24-48,24,48h54C601.25,192,609.61,182.79,607.74,172.86Z","className":"fa-primary","key":2})]);
}

TreePalm.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = TreePalm;

TreePalm.default = TreePalm;
